import { Middleware, Context } from '@nuxt/types'
import s from '~/utils/s'
import cookie from 'cookie'

const choiceCityMiddleware: Middleware = (context: Context) => {
  const chosenCity = s(context.store).regions.choiceCity
  const selectedCityName = s(context.store).regions.selectedCityName
  const currentRegion = s(context.store).regions.region
  let host = ''
  if (process.server) {
    host = context.req.headers.host ?? ''
  }
  const regexDomain = s(context.store).general.host?.replace('.', '\\.')
  const regexMain = new RegExp('^' + regexDomain + '(:\\d{1,5})?$', 'i')
  const regexSub = new RegExp('^([^.]*)\\.' + regexDomain + '(:\\d{1,5})?$', 'i')


  const isCityMismatch = selectedCityName && currentRegion && !currentRegion.cities.some(city => city.name === selectedCityName)

  if (regexMain.test(host)) {
    if (chosenCity && selectedCityName && !isCityMismatch) {
      s(context.store).general.setIsShowChoiceCity(false)
    } else {
      context.store.commit('regions/setSelectedCityName', null)
      const rawCookie = process.server
        ? cookie.parse(context.req.headers.cookie || '')['ga-cookies']
        : (context.app.$cookies.get('ga-cookies') as string | undefined)

      if (rawCookie) {
        try {
          const parsed = JSON.parse(rawCookie)
          if (parsed?.regions?._selectedCityName) {
            parsed.regions._selectedCityName = ''

            context.app.$cookies.set('ga-cookies', JSON.stringify(parsed), {
              path: '/',
              domain: `.${s(context.store).general.host}`
            })
          }
        } catch (e) {
          console.error('Ошибка при сбросе _selectedCityName из куки', e)
        }
      }


      s(context.store).general.setIsShowChoiceCity(true)
    }
  } else if (regexSub.test(host)) {
    s(context.store).general.setIsShowChoiceCity(false)
  }
}

export default choiceCityMiddleware
